// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"footer-module--footerContainer--31iQd","left":"footer-module--left--1IGS3","middle":"footer-module--middle--1EhIa","right":"footer-module--right--3SHW0"};